import actions from "./actions";

const {
  MANAGER_DASHBOARD_BEGIN,
  MANAGER_DASHBOARD_SUCCESS,
  MANAGER_DASHBOARD_ERR,
  MANAGER_DASHBOARD_RESET,
  MANAGER_PRICE_LIST_BEGIN,
  MANAGER_PRICE_LIST_SUCCESS,
  MANAGER_PRICE_LIST_ERR,
  MANAGER_PRICE_LIST_RESET,
  MANAGER_MODEL_DISCOUNT_BEGIN,
  MANAGER_MODEL_DISCOUNT_SUCCESS,
  MANAGER_MODEL_DISCOUNT_ERR,
  MANAGER_MODEL_DISCOUNT_RESET,
  MANAGER_DISCOUNT_CALCULATE_BEGIN,
  MANAGER_DISCOUNT_CALCULATE_SUCCESS,
  MANAGER_DISCOUNT_CALCULATE_ERR,
  MANAGER_DISCOUNT_CALCULATE_RESET,
  MANAGER_GENERATE_OTP_BEGIN,
  MANAGER_GENERATE_OTP_SUCCESS,
  MANAGER_GENERATE_OTP_ERR,
  MANAGER_GENERATE_OTP_RESET,
  MANAGER_VERIFY_OTP_BEGIN,
  MANAGER_VERIFY_OTP_SUCCESS,
  MANAGER_VERIFY_OTP_ERR,
  MANAGER_VERIFY_OTP_RESET,
  MANAGER_SEND_REQUEST_BEGIN,
  MANAGER_SEND_REQUEST_SUCCESS,
  MANAGER_SEND_REQUEST_ERR,
  MANAGER_SEND_REQUEST_RESET,
  MANAGER_HISTORY_BEGIN,
  MANAGER_HISTORY_SUCCESS,
  MANAGER_HISTORY_ERR,
  MANAGER_HISTORY_RESET,
  MANAGER_VIEW_BEGIN,
  MANAGER_VIEW_SUCCESS,
  MANAGER_VIEW_ERR,
  MANAGER_VIEW_RESET,
  MANAGER_ALTERNATIVE_METHOD_BEGIN,
  MANAGER_ALTERNATIVE_METHOD_SUCCESS,
  MANAGER_ALTERNATIVE_METHOD_ERR,
  MANAGER_ALTERNATIVE_METHOD_RESET,
} = actions;

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const managerDashboardReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case MANAGER_DASHBOARD_BEGIN:
      return { ...initialState, loading: true };
    case MANAGER_DASHBOARD_SUCCESS:
      return { ...initialState, data, loading: false };
    case MANAGER_DASHBOARD_ERR:
      return { ...initialState, error: err, loading: false };
    case MANAGER_DASHBOARD_RESET:
      return initialState;
    default:
      return state;
  }
};

export const managerPriceListReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case MANAGER_PRICE_LIST_BEGIN:
      return { ...initialState, loading: true };
    case MANAGER_PRICE_LIST_SUCCESS:
      return { ...initialState, data, loading: false };
    case MANAGER_PRICE_LIST_ERR:
      return { ...initialState, error: err, loading: false };
    case MANAGER_PRICE_LIST_RESET:
      return initialState;
    default:
      return state;
  }
};

export const managerModelDiscountReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case MANAGER_MODEL_DISCOUNT_BEGIN:
      return { ...initialState, loading: true };
    case MANAGER_MODEL_DISCOUNT_SUCCESS:
      return { ...initialState, data, loading: false };
    case MANAGER_MODEL_DISCOUNT_ERR:
      return { ...initialState, error: err, loading: false };
    case MANAGER_MODEL_DISCOUNT_RESET:
      return initialState;
    default:
      return state;
  }
};

export const managerDiscountCalculateReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case MANAGER_DISCOUNT_CALCULATE_BEGIN:
      return { ...initialState, loading: true };
    case MANAGER_DISCOUNT_CALCULATE_SUCCESS:
      return { ...initialState, data, loading: false };
    case MANAGER_DISCOUNT_CALCULATE_ERR:
      return { ...initialState, error: err, loading: false };
    case MANAGER_DISCOUNT_CALCULATE_RESET:
      return initialState;
    default:
      return state;
  }
};

export const managerGenerateOtpReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case MANAGER_GENERATE_OTP_BEGIN:
      return { ...initialState, loading: true };
    case MANAGER_GENERATE_OTP_SUCCESS:
      return { ...initialState, data, loading: false };
    case MANAGER_GENERATE_OTP_ERR:
      return { ...initialState, error: err, loading: false };
    case MANAGER_GENERATE_OTP_RESET:
      return initialState;
    default:
      return state;
  }
};

export const managerVerifyOtpReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case MANAGER_VERIFY_OTP_BEGIN:
      return { ...initialState, loading: true };
    case MANAGER_VERIFY_OTP_SUCCESS:
      return { ...initialState, data, loading: false };
    case MANAGER_VERIFY_OTP_ERR:
      return { ...initialState, error: err, loading: false };
    case MANAGER_VERIFY_OTP_RESET:
      return initialState;
    default:
      return state;
  }
};

export const managerSendRequestReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case MANAGER_SEND_REQUEST_BEGIN:
      return { ...initialState, loading: true };
    case MANAGER_SEND_REQUEST_SUCCESS:
      return { ...initialState, data, loading: false };
    case MANAGER_SEND_REQUEST_ERR:
      return { ...initialState, error: err, loading: false };
    case MANAGER_SEND_REQUEST_RESET:
      return initialState;
    default:
      return state;
  }
};

export const managerHistoryReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case MANAGER_HISTORY_BEGIN:
      return { ...initialState, loading: true };
    case MANAGER_HISTORY_SUCCESS:
      return { ...initialState, data, loading: false };
    case MANAGER_HISTORY_ERR:
      return { ...initialState, error: err, loading: false };
    case MANAGER_HISTORY_RESET:
      return initialState;
    default:
      return state;
  }
};

export const managerViewReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case MANAGER_VIEW_BEGIN:
      return { ...initialState, loading: true };
    case MANAGER_VIEW_SUCCESS:
      return { ...initialState, data, loading: false };
    case MANAGER_VIEW_ERR:
      return { ...initialState, error: err, loading: false };
    case MANAGER_VIEW_RESET:
      return initialState;
    default:
      return state;
  }
};

export const managerAlternativeMethodReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case MANAGER_ALTERNATIVE_METHOD_BEGIN:
      return { ...initialState, loading: true };
    case MANAGER_ALTERNATIVE_METHOD_SUCCESS:
      return { ...initialState, data, loading: false };
    case MANAGER_ALTERNATIVE_METHOD_ERR:
      return { ...initialState, error: err, loading: false };
    case MANAGER_ALTERNATIVE_METHOD_RESET:
      return initialState;
    default:
      return state;
  }
};
